
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-and-news",
      function () {
        return require("private-next-pages/blog-and-news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-and-news"])
      });
    }
  